import { tokens } from '@/theme'
import { TrelleborgMark } from './TrelleborgMark'

/**
 * Site footer, per the Orion Home Explorations design: a single dark rule
 * carrying the mark, the copyright, and the brand line. No link columns —
 * the earlier footer advertised Platform / Governance / Support sections
 * that were never wired to anything.
 *
 * Content is centred on the same container as the header so the mark in the
 * footer sits directly under the mark in the chrome.
 */
export function SiteFooter() {
  return (
    <footer style={{ background: tokens.inkPanel, marginTop: 96 }}>
      <div
        className="orion-pad"
        style={{
          maxWidth: tokens.containerMax,
          margin: '0 auto',
          padding: `26px ${tokens.containerPadX}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 16,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 18 }}>
          <TrelleborgMark variant="dark" size={26} showWordmark={false} />
          <span
            style={{
              fontFamily: tokens.fontBody,
              fontSize: 11.5,
              color: tokens.inkPanelText2,
              letterSpacing: '0.04em',
            }}
          >
            © {new Date().getFullYear()} Trelleborg AB · Industrial Solutions
          </span>
        </div>

        <span
          style={{
            fontFamily: tokens.fontDisplay,
            fontSize: 10.5,
            fontWeight: tokens.weightDemi,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            color: tokens.gold,
          }}
        >
          Protecting the Essential
        </span>
      </div>
    </footer>
  )
}
